import React from "react";
import { ELSA_BRAND_ASSETS } from "../config/brandAssets";

export const MOBILE_SPLASH_QUERY =
  "(max-width: 768px), (pointer: coarse) and (max-width: 1024px)";
export const getMediaQueryMatch = (query) => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }

  return window.matchMedia(query).matches;
};

const ElsaSplashVideo = ({
  className = "",
  fallbackClassName = "",
  fallbackSrc = ELSA_BRAND_ASSETS.emblemColor,
  alt = "ELSA GESTION",
}) => {
  return (
    <img
      src={fallbackSrc}
      alt={alt}
      className={fallbackClassName || className}
      draggable="false"
    />
  );
};

export default ElsaSplashVideo;
